const benefits = [
  {
    icon: "ri-team-line",
    text: "50+ Mitarbeiter + starkes Partnernetzwerk – keine Engpässe",
  },
  {
    icon: "ri-flashlight-line",
    text: "Schnelle Reaktionszeiten bei Problemen",
  },
  {
    icon: "ri-user-star-line",
    text: "Ein Ansprechpartner für alles",
  },
  {
    icon: "ri-building-line",
    text: "Erfahrung mit mehreren Objekten gleichzeitig",
  },
  {
    icon: "ri-map-pin-line",
    text: "Einsätze in ganz NRW möglich",
  },
];

export default function BenefitsSection() {
  return (
    <section id="vorteile" className="py-24 md:py-32 bg-[#111] relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/3 rounded-full -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/3 rounded-full translate-y-1/2 -translate-x-1/2 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-center">
          {/* Left */}
          <div className="lg:w-[40%]">
            <span className="text-xs font-bold tracking-widest uppercase text-gray-500 mb-4 block">Warum wir?</span>
            <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
              Warum Kunden mit uns arbeiten
            </h2>
            <div className="w-16 h-1 bg-white/30 rounded-full mb-8"></div>
            <p className="text-gray-400 text-base leading-relaxed mb-10">
              Wir sind kein gewöhnlicher Dienstleister. Wir denken mit, handeln schnell und liefern Ergebnisse – ohne dass Sie ständig nachfassen müssen.
            </p>
            <div className="bg-white/10 border border-white/10 rounded-2xl p-6">
              <p className="text-white text-xl font-bold leading-snug">
                Weniger Aufwand. Weniger Stress. Bessere Ergebnisse.
              </p>
            </div>
          </div>

          {/* Right */}
          <div className="lg:w-[60%] flex flex-col gap-5">
            {benefits.map((b, i) => (
              <div
                key={i}
                className="flex items-center gap-4 bg-white/5 border border-white/8 rounded-xl px-4 py-4 md:px-6 md:py-5 hover:bg-white/10 transition-all duration-300 group"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-white/10 group-hover:bg-white/20 transition-colors flex-shrink-0">
                  <i className={`${b.icon} text-white text-lg md:text-xl`}></i>
                </div>
                <p className="text-white/90 text-sm md:text-base font-medium flex-1">{b.text}</p>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-green-400 text-lg font-bold"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
